import { EventRegistrationStatus } from "interfaces/events";

export const LABELS_PER_STATUS: Record<EventRegistrationStatus, string> = {
  AVAILABLE: "Meld på",
  FULL: "Fullt",
  NOT_OPEN: "Ikke åpnet",
  NOT_RELEVANT: "Ikke relevant",
  REGISTERED: "Meld av",
  REGISTERED_FOR_WAITLIST: "Meld av venteliste",
  WAITLIST_AVAILABLE: "Meld på venteliste",
  BANNED: "Du er utestengt",
};
